import { EntityStatusState } from '@/store/root/root-store.model'
import { SetFilterValuesFuncParams } from '@ag-grid-enterprise/all-modules'
import { commonCenterService } from '@/api/services/common/center/common-center.service'
import { commonDepartmentTypeService } from '@/api/services/common/department-type/common-department-type.service'
import sessionStore from '@/session/sessionStore'
import { StoreUtils } from '@/shared/util/store-utils'

export class VtGridValues {
    static async centerValues(params: SetFilterValuesFuncParams): Promise<void> {
        const centers = await commonCenterService.getActiveCenters()
        params.success(centers.map(center => center.name))
    }

    static async departmentValues(params: SetFilterValuesFuncParams): Promise<void> {
        const departmentTypes = await commonDepartmentTypeService.getDepartmentTypesActive()
        params.success(departmentTypes.map(departmentType => departmentType.name))
    }

    static entityStatusStateValues(params: SetFilterValuesFuncParams, states: EntityStatusState[]): void {
        params.success(states.map(state => state.code))
    }

    static laboratoryValues(params: SetFilterValuesFuncParams): void {
        params.success(StoreUtils.laboratories.map(laboratory => laboratory.labName))
    }

    static priorityValues(params: SetFilterValuesFuncParams): void {
        const priorities: any[] = sessionStore.state.priorities
        params.success(priorities.map(priority => priority.level))
    }
}
